import React from "react";
import { Row, Col } from "antd";
import TextInput from "../../../CommonFormItems/TextInput/TextInput";
import SelectInput from "../../../CommonFormItems/SelectInput/SelectInput";
import CheckboxInput from "../../../CommonFormItems/CheckboxInput/CheckboxInput";

export default function ProximityShipmentForm({
  form,
  shipmentDetails,
  handleShipmentDetails,
  hasSpecialRole,
  hasRecipientSpecialPostCode,
  sameDayDelivery,
}) {
  const { getFieldDecorator, setFieldsValue } = form;

  return (
    <>
      <Row
        type="flex"
        justify="space-between"
        gutter={[16, 16]}
        className="pr-grid-row"
      >
        <Col xs={24} md={7} className="pr-col">
          <TextInput
            label="Referencia del cliente"
            getFieldDecorator={getFieldDecorator}
            name="clientReference"
            placeholder="Introduzca una referencia de cliente"
          />
        </Col>
        <Col xs={24} md={7} className="pr-col pr-col-offset">
          <TextInput
            label="Observaciones"
            getFieldDecorator={getFieldDecorator}
            name="observations"
            placeholder="Introduzca observaciones"
          />
        </Col>
        <Col xs={24} md={7} className="pr-col pr-col-offset">
          <SelectInput
            getFieldDecorator={getFieldDecorator}
            name="packagesTotal"
            label="Número de bultos"
            initialValue={{ key: 1, label: "1" }}
            options={Array.from({ length: 10 }, (_, i) => ({
              key: i + 1,
              value: `${i + 1}`,
              label: `${i + 1}`,
            }))}
            labelInValue={true}
            placeholder="Seleccione número de bultos..."
          />
        </Col>
      </Row>

      {hasSpecialRole && hasRecipientSpecialPostCode && (
        <Row
          type="flex"
          justify="space-between"
          gutter={[16, 16]}
          className="pr-grid-row"
        >
          <Col xs={24} md={5} className="pr-col">
            <TextInput
              label="Número tarifario"
              getFieldDecorator={getFieldDecorator}
              name="tariffNumber"
              required
              requiredMessage="Campo obligatorio"
              placeholder="Ej: 821599"
              pattern={/^[^\s]{1,15}$/}
              patternMessage="Valor no válido. No se permiten espacios."
            />
          </Col>
          <Col xs={24} md={3} className="pr-col pr-col-offset">
            <TextInput
              label="Valor neto (€)"
              getFieldDecorator={getFieldDecorator}
              name="netValue"
              required
              requiredMessage="Campo obligatorio"
              placeholder="Ej: 3.85"
              pattern={/^\d+(\.\d{1,2})?$/}
              patternMessage="Valor no válido."
            />
          </Col>
          <Col xs={24} md={3} className="pr-col pr-col-offset">
            <TextInput
              label="Peso neto (kg)"
              getFieldDecorator={getFieldDecorator}
              name="netWeight"
              required
              requiredMessage="Campo obligatorio"
              placeholder="Ej: 2.48"
              pattern={/^\d+(\.\d{1,3})?$/}
              patternMessage="Valor no válido."
            />
          </Col>
          <Col xs={24} md={3} className="pr-col pr-col-offset">
            <TextInput
              label="Cantidad"
              getFieldDecorator={getFieldDecorator}
              name="quantity"
              required
              requiredMessage="Campo obligatorio"
              placeholder="Ej: 10"
              pattern={/^[0-9]+$/}
              patternMessage="Valor no válido."
            />
          </Col>
          <Col xs={24} md={5} className="pr-col pr-col-offset">
            <TextInput
              label="Descripción"
              getFieldDecorator={getFieldDecorator}
              name="description"
              required
              requiredMessage="Campo obligatorio"
              placeholder="Ej: BABY_BOTTLE Item"
              pattern={/^(?! ).*(?<! )$/}
              patternMessage="Valor no válido. No espacios inicio/fin."
            />
          </Col>
        </Row>
      )}

      <Row
        type="flex"
        justify="space-between"
        gutter={[16, 16]}
        className="pr-grid-row pr-conditional-row"
      >
        <Col xs={24} md={7} className="checkboxes-column">
          <CheckboxInput
            getFieldDecorator={getFieldDecorator}
            setFieldsValue={setFieldsValue}
            name="electronicDelivery"
            label="Prueba entrega electrónica"
            initialValue={shipmentDetails?.electronicDelivery}
          />
          <CheckboxInput
            getFieldDecorator={getFieldDecorator}
            setFieldsValue={setFieldsValue}
            name="addresseeExclusiveDelivery"
            label="Entrega exclusiva al destinatario"
            initialValue={shipmentDetails?.addresseeExclusiveDelivery}
          />
          <CheckboxInput
            getFieldDecorator={getFieldDecorator}
            setFieldsValue={setFieldsValue}
            name="declaredValue"
            label="Valor declarado"
            callback={handleShipmentDetails}
            initialValue={shipmentDetails?.declaredValue}
          />
          <CheckboxInput
            getFieldDecorator={getFieldDecorator}
            setFieldsValue={setFieldsValue}
            name="paymentOnDelivery"
            label="Envío contrarreembolso"
            callback={handleShipmentDetails}
            initialValue={shipmentDetails?.paymentOnDelivery}
          />
          {sameDayDelivery && (
            <CheckboxInput
              getFieldDecorator={getFieldDecorator}
              setFieldsValue={setFieldsValue}
              name="sameDayDeliveryConfirmation"
              label="Entrega en el mismo día"
            />
          )}
        </Col>
        <Col xs={24} md={7} className="pr-col pr-col-offset">
          {shipmentDetails?.declaredValue ? (
            <TextInput
              label="Importe valor declarado (céntimos de €)"
              getFieldDecorator={getFieldDecorator}
              name="declaredValueAmount"
              required
              requiredMessage="Campo obligatorio"
              placeholder="Ej: 1125"
              pattern={/^\d+$/}
              patternMessage="Valor no válido."
            />
          ) : (
            <div className="pr-empty-slot" />
          )}
        </Col>

        <Col xs={24} md={7} className="pr-col pr-col-offset">
          {shipmentDetails?.paymentOnDelivery ? (
            <TextInput
              label="Importe envío contrarreembolso (céntimos de €)"
              getFieldDecorator={getFieldDecorator}
              name="paymentOnDeliveryAmount"
              required
              requiredMessage="Campo obligatorio"
              placeholder="Ej: 385"
              pattern={/^\d+$/}
              patternMessage="Valor no válido."
            />
          ) : (
            <div className="pr-empty-slot" />
          )}
        </Col>
      </Row>
    </>
  );
}
